import { gitbook, github, polygon } from "assets";

export const cardData = [
  {
    id: 1,
    image: gitbook,
    // title: "Git Book",
    text: `Our comprehensive whitepaper explores the cutting-edge technology behind Enter App. Lorem ipsum lorem ipsum
    Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum
    Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum`,
    link: `https://www.gitbook.com`,
  },
  {
    id: 2,
    image: github,
    // title: "Github",
    text: `Our comprehensive whitepaper explores the cutting-edge technology behind Enter App. Lorem ipsum lorem ipsum
    Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum
    Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum`,
    link: `https://www.github.com`,
  },
  {
    id: 3,
    image: polygon,
    // title: "Polygon Scan",
    text: `Our comprehensive whitepaper explores the cutting-edge technology behind Enter App. Lorem ipsum lorem ipsum
    Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum
    Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum Lorem ipsum lorem ipsum`,
    link: `https://www.polygonscan.com`,
  },
];
